<template>
  <div>
    <Well />
    <section
      id="novedades"
      class="section home-v6-release home-v6-release--anchor"
    >
      <div class="container">
        <header class="home-v6-release__header has-text-centered">
          <p class="home-v6-release__kicker">
            {{ $t("home.v6Release.kicker") }}
          </p>
          <h2 class="home-v6-release__title">
            {{ $t("home.v6Release.title") }}
          </h2>
          <p class="home-v6-release__subtitle">
            {{ $t("home.v6Release.subtitle") }}
          </p>
        </header>
        <div class="home-v6-release__cards">
          <article class="home-v6-release-card">
            <div class="home-v6-release-card__top">
              <div class="home-v6-release-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="12,3 20,8 20,16 12,21 4,16 4,8" />
                </svg>
              </div>
              <span class="home-v6-release-card__badge">
                {{ $t("home.v6Release.badgeNew") }}
              </span>
            </div>
            <h3 class="home-v6-release-card__heading">
              {{ $t("home.v6Release.polygonTitle") }}
            </h3>
            <p class="home-v6-release-card__desc">
              {{ $t("home.v6Release.polygonDescription") }}
            </p>
            <router-link
              class="home-v6-release-card__cta"
              :to="{ path: '/tutorials' }"
            >
              {{ $t("home.v6Release.polygonCta") }} →
            </router-link>
          </article>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container content">
        <h2 class="home-what-shademotion-heading">
          {{ $t("home.v6Release.whatShadeMotionDoesTitle") }}
        </h2>
        <p>
          <strong>{{ $t("home.programName") }}</strong>
          {{ $t("home.programDescription") }}
        </p>
        <figure class="image">
          <img
            src="@/assets/images/shades-results.png"
            alt=""
            style="max-width: calc(min(400px, 100%))"
          />
          <figcaption>{{ $t("home.shadesMap") }}</figcaption>
        </figure>
        <p>
          {{ $t("home.programFeature") }}
        </p>
        <ul id="bullets">
          <template>
            <li v-for="index in numberOfBulletsToDisplay" :key="index">
              {{ $t("home.programFeatures.feature" + index) }}
            </li>
          </template>
        </ul>
        <p style="color: #3273dc">
          <button class="button is-text" @click="showMoreOrLessBullets()">
            {{
              $t(
                numberOfBulletsToDisplay === 3
                  ? "home.showMore"
                  : "home.showLess",
              )
            }}
          </button>
        </p>
        <h2>{{ $t("home.acknowledgment") }}</h2>
        <p>
          {{ $t("home.sponsors") }}
        </p>
      </div>
    </section>
  </div>
</template>
<script>
import Well from "@/components/Well.vue";

export default {
  components: {
    Well,
  },
  data() {
    return {
      numberOfBulletsToDisplay: 3,
      showText: this.$i18n.t("home.showMore"),
    };
  },
  methods: {
    showMoreOrLessBullets() {
      this.numberOfBulletsToDisplay =
        this.numberOfBulletsToDisplay === 3 ? 12 : 3;
    },
  },
};
</script>
